//
import { upsertUnlinkedBankAccountForClient } from '@/services/BankAccounts/BankAccountUnlinked/UpsertBankAccountForClient'
//
import { notifyMessage, notifyProblem } from '@/services/notify'
import { ValidationError } from '@/services/errors'
//
export async function upsertUnlinked() {
  const json = await this.getUnlinkedUpsertDetails()
  if (json === false) {
    return
  }

  const { successful, message, exception } = await upsertUnlinkedBankAccountForClient({
    json,
    purpose: 'updated'
  })
  if (!successful) {
    if (exception instanceof ValidationError) {
      this.$refs.form.setErrors(exception.fields)
    }

    notifyProblem(message)
  } else {
    notifyMessage(message)
  }
}
